import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Heading,
} from '../../coreui';

const InfoBlock = ({
  heading,
  headingProps,
  children,
  ...props
}) => {
  return (
    <ExtendedFlex
      flexDirection="column"
      borderBottom={1}
      borderColor="gray.10"
      {...props}
    >
      <Heading
        type="H6"
        textTransform="uppercase"
        mt={60}
        mb={30}
        {...headingProps}
      >
        {heading}
      </Heading>
      {children}
    </ExtendedFlex>
  );
};

InfoBlock.propTypes = {
  heading: PropTypes.string,
  headingProps: PropTypes.object,
};

export default InfoBlock;
